module.exports = __webpack_public_path__ + "img/newFooter.41bf63f5.svg";